import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";

const Index = () => {
  const [activeTab, setActiveTab] = useState("0");

  return (
    <div className="tab-section-container">
      <div className="inner-tab-section-container">
        <p className="introduction-text">
          Med utsendelser får du unike muligheter til å gjøre masseutsendelser
          av e-post som kan personifiseres og sendes til hundrevis av bedrifter
          samtidig, bare ved et par klikk. På denne måten sparer du både tid og
          reduserer risiko for å sende duplikat eller noe som virker generisk og
          havner i søppelkurven.
          <br />
          <br />
          Man får i utgangspunktet 100 e-poster man kan sende ut i måneden
          dersom man har et standard Leadfind-abonnement, men du kan oppgradere
          og få tilgang på enda flere e-postutsendelser med å betale en ekstra
          månedlig kostnad. Du kan velge mellom flere ulike maksgrenser i
          forskjellige prisklasser.
        </p>
        <div className="accordion-container">
          <Accordion
            className="company-accordion"
            defaultActiveKey="0"
            activeKey={activeTab}
          >
            <Card className="single-card top">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="0"
                  onClick={() => setActiveTab("0")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "0" ? "active" : ""
                    }`}
                  >
                    {activeTab === "0" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Opprett en ny kanal
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="card-body">
                  <p className="description-text">
                    For å starte å sende e-post må du aller først sette opp en
                    kanal, og slik går du frem:
                  </p>
                  <ol className="description-list">
                    <li>
                      Gå til <span className="bold">"Utsendelser"</span> fra
                      menyen til venstre.
                    </li>
                    <li>
                      Trykk deretter på{" "}
                      <span className="bold">"Sett opp en ny kanal"</span>
                      -knappen.
                    </li>
                    <li>
                      Velg deretter kommunikasjonstype og trykk på{" "}
                      <span className="bold">"Gå videre"</span>-knappen.
                    </li>
                    <li>
                      Skriv inn et navn på kanalen din og trykk på{" "}
                      <span className="bold">"Gå videre"</span>-knappen.
                    </li>
                  </ol>
                  <p className="description-text">
                    Etter dette vil kanalen din bli satt opp, og du kan nå legge
                    til et domene.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card top">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="1"
                  onClick={() => setActiveTab("1")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "1" ? "active" : ""
                    }`}
                  >
                    {activeTab === "1" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Verifiser eierskap av domene
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Verifisering er siste steg unna å kunne sende e-post, og du
                    gjør det slik:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på{" "}
                      <span className="bold">"Sett opp & verifiser"</span>
                      -knappen øverst på siden.
                    </li>
                    <li>
                      Skriv inn domenenavnet ditt under{" "}
                      <span className="bold">"Domene"</span>.
                    </li>
                    <li>
                      Trykk deretter på{" "}
                      <span className="bold">"Gå videre"</span>-knappen.
                    </li>
                    <li>
                      Kopier og legg inn verdiene i tabellen som vises inn i din
                      egen DNS.
                    </li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Gå videre"</span>-knappen.
                    </li>
                  </ol>
                  <p className="description-text">
                    Vennligst merk deg at det kan ta alt fra 5 minutter til 24
                    timer før DNS endringene blir synlige. Dersom du er usikker
                    på hvordan du legger inn DNS-pekere kan du finne mer info{" "}
                    <a
                      target="_blank"
                      href="https://www.youtube.com/watch?v=QwkX7-ab09A"
                    >
                      her
                    </a>
                    . Dette gjelder alle tjenester.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="2"
                  onClick={() => setActiveTab("2")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "2" ? "active" : ""
                    }`}
                  >
                    {activeTab === "2" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Send en e-post
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Når du har satt opp kanal og verifisert domene kan du
                    umiddelbart komme i gang med e-postutsendelser. Slik går du
                    frem for å sende ut e-post:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på <span className="bold">"Ny utsendelse"</span>
                      -knappen i <span className="bold">Historikk</span>
                      -seksjonen.
                    </li>
                    <li>Velg kontaktlisten og mal fra nedtrekksmenyen.</li>
                    <li>Fyll deretter inn emne og e-post du vil sende fra.</li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Send e-post"</span>-knappen.
                    </li>
                  </ol>
                  <p className="description-text">
                    Vennligst merk deg at du må ha opprettet både en mal og en
                    kontaktliste for å sende ut e-post. Det tar som regel opp
                    til 30 minutter før sendingene er ferdig.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="3"
                  onClick={() => setActiveTab("3")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "3" ? "active" : ""
                    }`}
                  >
                    {activeTab === "3" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Slett et domene
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Dersom du ønsker å slette domenet som er tilknyttet kanalen
                    din går du frem på denne måten:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på <span className="bold">"Slett domene"</span>
                      -knappen øverst på siden.
                    </li>
                    <li>
                      Til slutt bekreft sletting ved å trykke på{" "}
                      <span className="bold">"Ja, slett domenet"</span>-knappen.
                    </li>
                  </ol>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card last">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="4"
                  onClick={() => setActiveTab("4")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "4" ? "active" : ""
                    }`}
                  >
                    {activeTab === "4" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Slett en kanal
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="4">
                <Card.Body className="card-body">
                  <p className="description-text">
                    For å slette en kanal gjør du følgende:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på <span className="bold">"Slett kanal"</span>
                      -knappen øverst på siden.
                    </li>
                    <li>
                      Til slutt bekreft sletting ved å trykke på{" "}
                      <span className="bold">"Ja, slett kanalen"</span>-knappen.
                    </li>
                  </ol>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Index;
